
import React, { useEffect, useState } from "react";
import { Modal } from "barte-design-system";

export const ResponseModal = ({ setReload, openResponseModal, responseModal, setOpenResponseModal }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (openResponseModal) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [openResponseModal]);

  const handleClose = () => {
    setIsOpen(false);
    setOpenResponseModal(false);
    setReload((prev) => prev + 1);
  };

  return (
    <>
      <Modal
        isOpen={isOpen && responseModal?.error === true}
        title={responseModal?.title ?? "Erro"}
        onClose={handleClose}
        footer={{
          primaryButton: { children: "Ok", onClick: handleClose, variant: "outline" },
        }}
      >
        <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
          <img width="24" height="24" src="/images/icons/ErrorIcon.svg" alt="" />
          <p style={{ fontSize: "0.875rem" }}>{responseModal?.description}</p>
        </div>
      </Modal>

      <Modal
        isOpen={isOpen && responseModal && responseModal?.error !== true}
        title="Seu estorno está em processamento"
        onClose={handleClose}
        footer={{
          primaryButton: { children: "Ok", onClick: handleClose, variant: "fill" },
        }}
      >
        <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
          <img width="24" height="24" src="/images/icons/ProcessIcon.svg" alt="" />
          <p style={{ fontSize: "0.875rem" }}>O estorno pode ser concluído em até 36 horas. Por favor aguarde.</p>
        </div>
      </Modal>
    </>
  );
};
